<template>
    <!--Nav start-->
    <b-navbar v-bind:class="{ darkHeader: scrollpage >60 }" type="dark" class="theme-nav fixed-top" toggleable="lg" fixed="top" v-b-scrollspy="60" >
        <div class="container">
            <b-navbar-brand class="navbar-brand" :href='"/"'><img :src='"../assets/images/logo.png"' alt="logo"></b-navbar-brand>
            <b-navbar-toggle  class="navbar-brand"  right-alignment  target="nav_collapse">
                <span class="navbar-toggler-icon"><i class="fa fa-align-justify" aria-hidden="true"></i></span>
            </b-navbar-toggle>
            <b-collapse class="default-nav" is-nav id="nav_collapse">
                <b-navbar-nav  class="navbar-nav ml-auto" id="mymenu">
                    <b-nav-item href="#products">ก้าวไกลศูนย์กลางผลิตภัณฑ์ฯ</b-nav-item>
                    <b-nav-item href="#development">ก้าวไกลเพื่อสังคมฯ</b-nav-item>
                    <b-nav-item href="#annual_report">1 ปี กยท. ก้าวไกลฝ่าวิกฤติฯ</b-nav-item>
                    <b-nav-item href="#research">ก้าวไกล พัฒนางานวิจัยและนวัตกรรมยาง</b-nav-item>
                    <b-nav-item href="#digital">ก้าวไกลยุคดิจิทัล</b-nav-item>
                    <b-nav-item href="#glorifying_person">กยท. เชิดชูคนดี</b-nav-item>

                  
                </b-navbar-nav>
            </b-collapse>
        </div>
    </b-navbar>
    <!--Nav end -->
</template>
<script>
export default {
  name: 'Navbar',
  data () {
    return {
      scrollpage: 0
    }
  },
  methods: {
    handleScroll: function (event) {
      this.scrollpage = window.scrollY
    }
  },
  created: function () {
    window.addEventListener('scroll', this.handleScroll)
  }
}
</script>
